import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/leaf.png";
import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/editor.jpg";
import chatify from "../../Assets/Projects/chatify.png";
import suicide from "../../Assets/Projects/suicide.png";
import bitsOfCode from "../../Assets/Projects/bit_image.jpg";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works / Programs  </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects We've worked on recently, feel free to visit our Github for more Programming Codes.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Face Security "
              description= "A facial recognition security system with SMS notification functionality is a modern access control solution. It uses advanced facial recognition technology to identify authorized users. When an authorized person is detected, the system sends an SMS notification to a designated recipient, providing real-time updates on who has entered a secure area."
              ghLink=" https://github.com/mcjibreen07/Face_Security"
              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="TRAINING 200+ JAMB APPLICANT "
              description="Trained more than 200 Student for the Usage of CBT during Jamb Examination "
              ghLink="https://m.facebook.com/story.php?story_fbid=pfbid02SKuHo5g5c6KCE2WwVbSPicM2kivdne7hXkrRNYMu2u2eUqLiiUBRRqp9dSRYW9HBl&id=107272565282373&eav=AfarRFm3L0wEQmYQaD8HZdX85LlYbM1NS5_b_JSPGaw-cHco4ZgNusFZhPxSNU7UfHk&paipv=0"
              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="NPC Training "
              description=" Adhoc Staff Training for NPC23"
              ghLink="https://web.facebook.com/geidaminnovation?refid=52&paipv=0&eav=Afb4DH-S4dsVSKZeWRzWDRlRvA3hTcullQBP5ccBHBAB5TU4pv7qYcUVrI39VGjH4_w&_rdc=1&_rdr"
                          
            />
          </Col>

                  </Row>
      </Container>
    </Container>
  );
}

export default Projects;
